import React from "react";
import Layout from "../Layout/Layout";

function Dashboard() {
  return (
    <Layout>
      <div className="p-5 bg-gray-100 min-h-screen">
        {/* <h6 className="text-2xl font-bold text-gray-800 mb-5">Admin Dashboard</h6> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="bg-white p-5 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold">Users</h3>
            <p className="text-gray-600">Manage system users</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold">Analytics</h3>
            <p className="text-gray-600">View system analytics</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold">Settings</h3>
            <p className="text-gray-600">Configure system settings</p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Dashboard;
